import {
  HttpClient,
  HttpEventType,
  HttpHeaders,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { saveAs as importedSaveAs } from 'file-saver';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  constructor(private http: HttpClient) {}

  list(params?: { status?: string; page?: number; limit?: number; professionalId?: string }) {
    const query = new URLSearchParams();
    if (params?.status) query.set('status', params.status);
    if (params?.professionalId) query.set('professionalId', params.professionalId);
    if (params?.page) query.set('page', String(params.page));
    if (params?.limit) query.set('limit', String(params.limit));

    const suffix = query.toString() ? `?${query.toString()}` : '';
    return this.http.get(`${environment.apiUrl}admin/files${suffix}`).pipe(map((result) => result));
  }

  update(file: File, fileId: string, fieldname: string, description: string, professionalId: string) {
    const formData: FormData = new FormData();

    formData.append('document', file);
    formData.append('fieldname', fieldname);
    formData.append('description', description);
    formData.append('professionalId', professionalId);

    const req = new HttpRequest(
      'PUT',
      `${environment.apiUrl}admin/files/${fileId}`,
      formData,
      {
        reportProgress: true,
        responseType: 'json',
      }
    );

    return this.http.request(req);
  }

  check(status: string, fileId: string, reason?: string) {
    const body: any = { status };
    if (reason) {
      body.reason = reason;
    }
    
    return this.http
      .patch(
        `${environment.apiUrl}admin/files/${fileId}/status`,
        body
      )
      .pipe(map((result) => result));
  }

  download(fileId: string, mimetype: string, filename: string) {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', mimetype);

    const endpoint = `${environment.apiUrl}admin/files/${fileId}/download`;

    return this.http
      .get(endpoint, { headers, responseType: 'blob' })
      .pipe(map((result) => {
        const convertBlob = new Blob([result], { type: mimetype });
        importedSaveAs(convertBlob, filename);

        return convertBlob;
      }))
  }

  getFile(fileId: string) {
    let headers = new HttpHeaders();

    const endpoint = `${environment.apiUrl}admin/files/${fileId}/download`;

    return this.http
      .get(endpoint, { headers, responseType: 'arraybuffer' })
      .pipe(
        map((result) => {
          let file = new Blob([result], { type: 'application/pdf' });
          return URL.createObjectURL(file);
        })
      );
  }

  getImageUrl(fileId: string) {
    const endpoint = `${environment.apiUrl}admin/files/${fileId}/download`;

    return this.http
      .get(endpoint, { responseType: 'arraybuffer', observe: 'response' })
      .pipe(
        map((response) => {
          const contentType = response.headers.get('Content-Type') || 'image/jpeg';
          const blob = new Blob([response.body!], { type: contentType });
          return URL.createObjectURL(blob);
        })
      );
  }
}
